<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<notifier-container></notifier-container>
